import React from 'react'
import { Card, CardContent, Typography, Autocomplete, TextField, Checkbox, Chip, Box, CircularProgress } from '@mui/material';
import { Engineering, People } from '@mui/icons-material';
import { Controller, useFormContext } from 'react-hook-form';
import CSVMatchUpload from './CSVMatchUpload';
const ExpertSelection = ({ filteredData, isLoading, getFullName, notificationData, setNotificationData }) => {
        const { control, setValue } = useFormContext();
        const handleExpertSelectionChange = (event, newValues) => {
            const hasSelectAll = newValues.some(val => val.id === '__all__');

            if (hasSelectAll) {
                const selectedExperts = notificationData.expertFilters?.selectedExperts || [];
                const isAllSelected = selectedExperts.length === filteredData.length;
                
                if (isAllSelected) {
                    // setNotificationData(prev => ({
                    //     ...prev,
                    //     expertFilters: {
                    //         ...prev.expertFilters,
                    //         selectedExperts: []
                    //     }
                    // }));
                    return [];
                } else {
                    // setNotificationData(prev => ({
                    //     ...prev,
                    //     expertFilters: {
                    //         ...prev.expertFilters,
                    //         selectedExperts: filteredData.map(item => ({ id: item.id }))
                    //     }
                    // }));
                    return filteredData.map(item => ({ id: item.id }));
                }
            } else {
                // setNotificationData(prev => ({
                //     ...prev,
                //     expertFilters: {
                //         ...prev.expertFilters,
                //         selectedExperts: newValues.map(item => ({ id: item.id }))
                //     }
                // }));
                return newValues.map(item => ({ id: item.id }));
            }
        };

        const selectedExperts = notificationData.expertFilters?.selectedExperts || [];
        const selectedIds = selectedExperts.map(e => e.id);
        const isAllSelected = filteredData.length > 0 && selectedIds.length === filteredData.length;
        const isIndeterminate = selectedIds.length > 0 && selectedIds.length < filteredData.length;

        const selectAllOption = {
            id: '__all__',
            profile: { firstName: 'Select All Experts' },
        };

        const optionsWithSelectAll = [selectAllOption, ...filteredData];

        return (
            <Card variant="outlined">
                <CardContent>
                    <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 600, display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Engineering fontSize="small" />
                        Select Experts to Notify
                    </Typography>
                    <Controller
                        name="expertFilters.selectedExperts"
                        control={control}
                        rules={{ required: true,
                            validate: (value) => (value && Object.keys(value).length > 0) || 'Select expert'
                         }}
                        render ={({field: { onChange, value },fieldState:{error}})=>(
                            <Autocomplete
                                multiple
                                disableCloseOnSelect
                                options={optionsWithSelectAll}
                                value={value}
                                loading={isLoading}
                                // onChange={handleExpertSelectionChange}
                                onChange={(event, newValue) => {
                                    let nValue = handleExpertSelectionChange(event, newValue);
                                    onChange(nValue);
                                }}
                                getOptionDisabled={(option) => option.id === '__all__'}
                                getOptionLabel={(option) => {
                                    if (option.id === '__all__') return 'Select All Experts';
                                    const profile = option.UserProfile || {};
                                    return `${getFullName(profile)} (${option.mobileNumber || ''})`;
                                }}
                                isOptionEqualToValue={(option, val) => option.id === val.id}
                                renderOption={(props, option, { selected }) => {
                                    if (option.id === '__all__') {
                                        return (
                                            <li {...props}>
                                                <Checkbox
                                                    checked={isAllSelected}
                                                    indeterminate={isIndeterminate}
                                                    size="small"
                                                    sx={{ mr: 1 }}
                                                />
                                                <Typography sx={{ fontSize: '0.8rem', fontWeight: 500 }}>
                                                    Select All Experts
                                                </Typography>
                                            </li>
                                        );
                                    }

                                    const profile = option.UserProfile || {};
                                    const fullName = getFullName(profile);
                                    return (
                                        <li {...props}>
                                            <Checkbox checked={selected} size="small" sx={{ mr: 1 }} />
                                            <Box>
                                                <Typography sx={{ fontSize: '0.8rem', fontWeight: 500 }}>
                                                    {fullName}
                                                    {/* <Box component="span" sx={{ ml: 1, fontSize: '0.7rem', color: 'primary.main', fontWeight: 600 }}>
                                                        {option.specialty}
                                                    </Box> */}
                                                    <Box component="span" sx={{ ml: 1, fontSize: '0.7rem', color: '#666' }}>
                                                        ({option.mobileNumber})
                                                    </Box>
                                                </Typography>
                                                <Typography sx={{ fontSize: '0.65rem', color: 'text.secondary' }}>
                                                    {/* Coverage: {option.coverageArea}
                                                    {option.coordinates && (
                                                        <Box component="span" sx={{ ml: 1 }}>
                                                            | Location: {option.coordinates.lat.toFixed(4)}, {option.coordinates.lng.toFixed(4)}
                                                        </Box>
                                                    )} */}
                                                </Typography>
                                            </Box>
                                        </li>
                                    );
                                }}
                                renderTags={(tagValue, getTagProps) => {
                                    const selectedIds = tagValue.map(e => e.id);
                                    const allSelected = filteredData.length > 0 && selectedIds.length === filteredData.length;

                                    if (allSelected) {
                                        return (
                                            <Chip
                                                label={`All Experts (${filteredData.length})`}
                                                size="small"
                                                sx={{ fontSize: '0.7rem', height: '24px', mr: 0.5 }}
                                            />
                                        );
                                    }

                                    return tagValue.map((option, index) => {
                                        const profile = filteredData.find(item => item.id === option.id)?.UserProfile || {};
                                        const fullName = getFullName(profile);
                                        return (
                                            <Chip
                                                label={fullName}
                                                size="small"
                                                {...getTagProps({ index })}
                                                sx={{
                                                    fontSize: '0.7rem',
                                                    height: '24px',
                                                    mr: 0.5
                                                }}
                                            />
                                        );
                                    });
                                }}
                                noOptionsText={<span style={{ fontSize: '0.75rem' }}>No experts found</span>}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        size="small"
                                        placeholder="Select experts to notify"
                                        InputProps={{
                                            ...params.InputProps,
                                            style: { fontSize: '0.75rem', color: '#000' },
                                            endAdornment: (
                                                <>
                                                    {isLoading && <CircularProgress size={16} />}
                                                    {params.InputProps.endAdornment}
                                                </>
                                            ),
                                        }}
                                    />
                                )}
                            />
                        )}
                    />
                    
                    {/* CSV Upload for Bulk Selection */}
                    <CSVMatchUpload
                        registeredList={filteredData}
                        audienceType="expert"
                        isLoading={isLoading}
                        onMatch={(matchedUsers) => {
                            // Map matched users to the format expected by the autocomplete
                            const newSelection = matchedUsers.map(user => ({ id: user.id }));
                            
                            // Update the form control value
                            setValue('expertFilters.selectedExperts', newSelection, { shouldValidate: true });
                            
                            // Also update notificationData for consistency
                            setNotificationData(prev => ({
                                ...prev,
                                expertFilters: {
                                    ...prev.expertFilters,
                                    selectedExperts: newSelection
                                }
                            }));
                        }}
                    />
                    
                </CardContent>
            </Card>
        );
    };

export default ExpertSelection
